<template>
  <div class="w-full">
    <select
        class="w-full"
        :class="props.class"
        v-model="selectedValue"
        @change="emitChange"
    >
      <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import { ref, defineProps, defineEmits } from 'vue';

// Define props
const props = defineProps<{
  options: { value: number | string; label: string }[];
  modelValue: number | string;
  class: string;
}>();

// Define emits
const emit = defineEmits(['update:modelValue']);

// Reactive state
const selectedValue = ref(props.modelValue);

// Emit changes when selection updates
const emitChange = () => {
  emit('update:modelValue', selectedValue.value);
};
</script>
